var $f906d8c9d57a8ac7$exports = {};
$f906d8c9d57a8ac7$exports = {
    "collapse": `Strni`,
    "expand": `Raz\u{161}iri`
};


export {$f906d8c9d57a8ac7$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
